<template>
	<div id="team" class='page'>

		<div class="page-content">
			<div class="header_img" v-bind:stsyle="{backgroundImage: 'url(' + p.header_image.url.replace('?auto=compress,format','') + ')'}">
				<img :src="p.header_image.url.replace('?auto=compress,format','')" alt="">
			</div>
			<div class="beschreibungen">
				<div class="beschreibung" v-for='(beschreibung, index) in p.beschreibungen'>
					<div class="name">
						{{beschreibung.name}}
					</div>
					<div class="titel">
						{{beschreibung.titel}}
					</div>
					<div class="splitline"></div>
					<div v-html="beschreibung.text[0].text" class="text">
					</div>

				</div>
			</div>
			<div class="team-slots">
				<div class="slot" v-for='(slot, index) in p.team'>
					<div class="slot_img" v-bind:style="{backgroundImage: 'url(' + slot.image.url.replace('?auto=compress,format','') + ')'}"> </div>
					<div class="name">
						{{slot.name}}

					</div>
					<div class="titel">
						{{slot.titel}}
					</div>

				</div>

			</div>


			<!-- <p v-html='p.text'></p>

        <!-- </div> -->
    </div>
    </div>
</template>
<script>
	export default {
		name: 'team',
		components: {
		},
		props: {
			langsufix: String,
			sidenav: Array,
		},
		data() {
			return {
				p: {}
			}
		},
		created () {
			this.getContent();
		},
		methods: {
            scrollToTop() {
                window.scrollTo(0,0);
            },
            close () {
                this.$router.push('/');
            },
            getContent () {
                this.$prismic.client.getByUID('page-team','team-'+this.langsufix)
                .then((document) => {
                   console.log(document.data);
                   this.p = document.data;
               })
            },
        }
    }
</script>

<style lang='less' scoped>
@import '../less/variables.less';
.page-content {
	width:80%;
	min-height: 800px;
	background-color: white;
	text-align: left;
	color: @g1;
	.fm(12px);
	padding: 100px 10%;

	.header_img {
		// background-image: url("/images/image");
		// background-repeat: no-repeat;
		// background-position: top center;
		// background-size: 100% auto;
		position: relative;
		width: 85%;
		// height: 525px;
		margin-left:auto;
		margin-right:auto;
		left:0;
		right:0;
		// background-color: red;
		img {
			width: 100%;
		}


	}
	.team-slots {
		margin-left:auto;
		margin-right:auto;
		left:0;
		right:0;
		position: relative;
		width: 85%;
		margin-top: 80px;
		.slot {
			position: relative;
			width: 20%;
			min-width: 150px;
			display: inline-block;
			margin-right: 5%;
			.slot_img {
				position: relative;
				width: 100%;
				height: 150px;
				background-color: rgba(0,0,0,0.1);
				background-repeat: no-repeat;
				background-position: center center;
				background-size: cover;


			}
			.name {
				margin-top: 15px;
				.fmb(12px);
				text-transform: uppercase;

			}
			.titel {
				.fmb(12px);

				margin-bottom: 50px;
				opacity: 0.5;

			}
		}
	}
	.beschreibungen {
		// background-color: red;
		position: relative;
		width: 85%;
		margin-left:auto;
		margin-right:auto;
		left:0;
		right:0;
		margin-top: 50px;

		.beschreibung {
			width: 35%;
			position: relative;
			min-height: 150px;
			display: inline-block;
			// background-color: yellow;
			margin-right: 15%;
			.name {
				.fmb(20px);
				text-transform: uppercase;
			}
			.titel {
				.fmb(12px);
				color: rgba(0,0,0,0.5);
				margin-bottom: 15px;
			}
			.text {
				.fm(14px);
				color: @g1;
				opacity: 0.7
			}


		}
		.splitline {
			height: 3px;
			background-color: black;
		}

	}

}
h1 {
	.fmb(40px);
	color: @g1;
}
p {
	.fm(12px);
	color: @g1;
}
.page {
	margin-top: 200px;
}
</style>
